export default __webpack_public_path__ + "static/media/background-syndic-one.1755078a.png";